'use strict';

var react = require('react');
var yogokit = require('@wishket/yogokit');

const useDropdown = ({ items, onItemClick, disabled })=>{
    const [isListOpen, setIsListOpen] = react.useState(false);
    const [focusedIndex, setFocusedIndex] = react.useState(-1);
    const ref = react.useRef(null);
    const isListOpenRef = react.useRef(isListOpen);
    const closeList = react.useCallback(()=>{
        if (!isListOpenRef.current) return;
        setIsListOpen(false);
        setFocusedIndex(-1);
    }, []);
    yogokit.useClickOutside(ref, closeList);
    const handleItemClick = (item)=>{
        onItemClick(item);
        closeList();
    };
    const toggleListOpen = (e)=>{
        e === null || e === void 0 ? void 0 : e.preventDefault();
        if (disabled) return;
        setIsListOpen((prev)=>{
            isListOpenRef.current = !prev;
            return !prev;
        });
    };
    const handleKeyDown = (e)=>{
        if (!isListOpen) return;
        switch(e.key){
            case 'ArrowDown':
                e.preventDefault();
                setFocusedIndex((prev)=>{
                    const nextIndex = prev < items.length - 1 ? prev + 1 : prev;
                    const listElement = ref.current;
                    if (listElement) {
                        const itemElement = listElement.querySelectorAll('li')[nextIndex];
                        itemElement === null || itemElement === void 0 ? void 0 : itemElement.scrollIntoView({
                            block: 'nearest'
                        });
                    }
                    return nextIndex;
                });
                break;
            case 'ArrowUp':
                e.preventDefault();
                setFocusedIndex((prev)=>{
                    const prevIndex = prev > 0 ? prev - 1 : prev;
                    const listElement = ref.current;
                    if (listElement) {
                        const itemElement = listElement.querySelectorAll('li')[prevIndex];
                        itemElement === null || itemElement === void 0 ? void 0 : itemElement.scrollIntoView({
                            block: 'nearest'
                        });
                    }
                    return prevIndex;
                });
                break;
            case 'Enter':
                e.preventDefault();
                if (focusedIndex >= 0) {
                    handleItemClick(items[focusedIndex]);
                }
                break;
            case 'Escape':
                e.preventDefault();
                closeList();
                break;
        }
    };
    return {
        isListOpen,
        focusedIndex,
        ref,
        handleItemClick,
        toggleListOpen,
        handleKeyDown
    };
};

module.exports = useDropdown;
